import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable , of} from 'rxjs';
import { environment } from '../../environments/environment';
import { Carteira } from '../_models/carteira/carteira';
import { catchError, tap } from 'rxjs/operators';

export const HTTP_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Access-Control-Allow-Credentials' : 'true',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
  })
};

@Injectable({ providedIn: 'root' })
export class CarteiraService {

  constructor(private http: HttpClient) { }

  getAllCarteiras(): Observable<Carteira[]> {
     return this.http.get<any>(`${environment.authorizedUrls.bsCobrancaUrl}/carteira`);
  }

  inserir(carteira: Carteira): Observable<Carteira> {
    return this.http.post<Carteira>(`${environment.authorizedUrls.bsCobrancaUrl}/carteira/incluir`, {
      carteira
    }).pipe(
    tap((newCarteira: Carteira) => console.log(`added carteira w/ id=${newCarteira.id}`)),
    catchError(this.handleError<Carteira>('inserir'))
    );
  }

  atualizar(carteira: Carteira): Observable<Carteira> {
     return this.http.post(`${environment.authorizedUrls.bsCobrancaUrl}/carteira/atualizar`, {
      carteira
    }).pipe(
    tap((newCarteira: Carteira) => console.log(`added carteira w/ id=${newCarteira.id}`)),
    catchError(this.handleError<Carteira>('atualizar'))
    );
  }

  deletar(carteira: Carteira) {
    return this.http.delete<string>(`${environment.authorizedUrls.bsCobrancaUrl}/carteira/excluir/` + carteira.id).subscribe(
        response => console.log(response),
        err => console.log(err));
  }


      handleError<T>(operation = 'operation', result?: T) {
      return (error: any): Observable<T> => {
        // TODO: send the error to remote logging infrastructure
        console.error(error); // log to console instead

        // TODO: better job of transforming error for user consumption
        console.log(`${operation} failed: ${error.message}`);

        // Let the app keep running by returning an empty result.
        return of(result as T);
      };
    }


}
